/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface GetAppointmentHourResponse
 */
export interface GetAppointmentHourResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetAppointmentHourResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof GetAppointmentHourResponse
     */
    day: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentHourResponse
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentHourResponse
     */
    endTime: string;
}



/**
 * Check if a given object implements the GetAppointmentHourResponse interface.
 */
export function instanceOfGetAppointmentHourResponse(value: object): value is GetAppointmentHourResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function GetAppointmentHourResponseFromJSON(json: any): GetAppointmentHourResponse {
    return GetAppointmentHourResponseFromJSONTyped(json, false);
}

export function GetAppointmentHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'day': DayOfWeekFromJSON(json['day']),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function GetAppointmentHourResponseToJSON(json: any): GetAppointmentHourResponse {
    return GetAppointmentHourResponseToJSONTyped(json, false);
}

export function GetAppointmentHourResponseToJSONTyped(value?: GetAppointmentHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'day': DayOfWeekToJSON(value['day']),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

